
import React from "react";
import MainComponent from "./MainComponent";
import './A3/A3.css';

class A3 extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return <MainComponent appVersion = "A3" />;
    }
}

export default A3;